import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-my-newsletter',
  templateUrl: './my-newsletter.component.html',
  styleUrls: ['./my-newsletter.component.scss']
})
export class MyNewsletterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
